// extracted by mini-css-extract-plugin
export default {"block":"RosterBlock_block__kJjWu","date":"RosterBlock_date__Wj1A-","old":"RosterBlock_old__MpJrE","small":"RosterBlock_small__+krwT","items":"RosterBlock_items__BFktk"};